import * as z from "zod";

// TODO: Remove this endpoint in a week or so. Callers have been removed.

export const getCustomerTags = {
  name: "getCustomerTags" as const,
  input: z.null(),
  output: z.object({ tags: z.array(z.string()) }),
};
